// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__U5Q9j","label":"index_label__GRdur","exist":"index_exist__0B85u"};